/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRole = exports.Semantic = exports.Scene = exports.MIME = exports.MediaStatus = exports.Locale = exports.ActivityType = exports.Country = void 0;
/** Countries. */
var Country;
(function (Country) {
    /** Spain. */
    Country[Country["ES"] = 0] = "ES";
    /** France. */
    Country[Country["FR"] = 1] = "FR";
    /** United Kingdom. */
    Country[Country["GB"] = 2] = "GB";
    /** United States. */
    Country[Country["US"] = 3] = "US";
})(Country = exports.Country || (exports.Country = {}));
/** Activity types. */
var ActivityType;
(function (ActivityType) {
    /** Activity just displays some content (text/documents/images/mixed). */
    ActivityType[ActivityType["Content"] = 0] = "Content";
    /** Liveboard where everyone may draw in real-time. */
    ActivityType[ActivityType["LiveBoard"] = 1] = "LiveBoard";
    /** Photo/images mosaic board. */
    ActivityType[ActivityType["Mosaic"] = 2] = "Mosaic";
    /** Presentation */
    ActivityType[ActivityType["Presentation"] = 3] = "Presentation";
    /**
     * Quiz with series of questions
     * represented with 2D image/labels answers.
     */
    ActivityType[ActivityType["Quizz2D"] = 4] = "Quizz2D";
    /** Quiz with 3D/2.5D questions. */
    ActivityType[ActivityType["Quizz3D"] = 5] = "Quizz3D";
    /** Activity for screen-type touchpoints shows video content. */
    ActivityType[ActivityType["Screen"] = 6] = "Screen";
    /** SCORM activity type. */
    ActivityType[ActivityType["SCORM"] = 7] = "SCORM";
    /** Kiosk map. */
    ActivityType[ActivityType["Map"] = 8] = "Map";
    /** Kiosk sessions map. */
    ActivityType[ActivityType["SessionMap"] = 9] = "SessionMap";
    /** Url Redirect */
    ActivityType[ActivityType["UrlRedirect"] = 10] = "UrlRedirect";
})(ActivityType = exports.ActivityType || (exports.ActivityType = {}));
/** Locales. */
var Locale;
(function (Locale) {
    /** English. */
    Locale[Locale["en"] = 0] = "en";
    /** Spanish. */
    Locale[Locale["es"] = 1] = "es";
    /** French.*/
    Locale[Locale["fr"] = 2] = "fr";
})(Locale = exports.Locale || (exports.Locale = {}));
/** Status for media file processing. */
var MediaStatus;
(function (MediaStatus) {
    /** Media is being processed. */
    MediaStatus[MediaStatus["Processing"] = 0] = "Processing";
    /** Media has been processed succesfully. */
    MediaStatus[MediaStatus["Success"] = 1] = "Success";
    /** There was an error processing media. */
    MediaStatus[MediaStatus["Error"] = 2] = "Error";
})(MediaStatus = exports.MediaStatus || (exports.MediaStatus = {}));
/** MIME types. */
var MIME;
(function (MIME) {
    /** text/csv MIME type. */
    MIME[MIME["text/csv"] = 0] = "text/csv";
    /** text/plain MIME type. */
    MIME[MIME["text/plain"] = 1] = "text/plain";
    /** application/pdf MIME type. */
    MIME[MIME["application/pdf"] = 2] = "application/pdf";
    /** image/webp MIME type. */
    MIME[MIME["image/webp"] = 3] = "image/webp";
    /** audio/webm MIME type. */
    MIME[MIME["audio/webm"] = 4] = "audio/webm";
    /** video/webm MIME type. */
    MIME[MIME["video/webm"] = 5] = "video/webm";
})(MIME = exports.MIME || (exports.MIME = {}));
/** Scenes in the environment. */
var Scene;
(function (Scene) {
    /** Apartment scene. */
    Scene[Scene["Apartment"] = 0] = "Apartment";
    /** Campus scene. */
    Scene[Scene["Campus"] = 1] = "Campus";
    /** Loft scene. */
    Scene[Scene["Loft"] = 2] = "Loft";
    /** Office scene. */
    Scene[Scene["Office"] = 3] = "Office";
    /** Pool scene. */
    Scene[Scene["Pool"] = 4] = "Pool";
    /** Store scene. */
    Scene[Scene["Store"] = 5] = "Store";
    /** Warehouse scene. */
    Scene[Scene["Warehouse"] = 6] = "Warehouse";
})(Scene = exports.Scene || (exports.Scene = {}));
/** Semantic UI hints. */
var Semantic;
(function (Semantic) {
    /** Success. */
    Semantic[Semantic["Success"] = 0] = "Success";
    /** Information. */
    Semantic[Semantic["Info"] = 1] = "Info";
    /** Warning. */
    Semantic[Semantic["Warning"] = 2] = "Warning";
    /** Danger. */
    Semantic[Semantic["Danger"] = 3] = "Danger";
})(Semantic = exports.Semantic || (exports.Semantic = {}));
/** Roles for users. */
var UserRole;
(function (UserRole) {
    /** Brand influencer (Student) role. Limited access. */
    UserRole[UserRole["BrandInfluencer"] = 0] = "BrandInfluencer";
    /**
     * Community manager role.
     * Access to scenes, activities, touchpoints...
     */
    UserRole[UserRole["CommunityManager"] = 1] = "CommunityManager";
    /** Guest role applies to users awaiting account confirmation. */
    UserRole[UserRole["Guest"] = 2] = "Guest";
    /** RetailSalesAssociate (Student) role. Limited access. */
    UserRole[UserRole["RetailSalesAssociate"] = 3] = "RetailSalesAssociate";
    /** Absolute administrator with full access. */
    UserRole[UserRole["Root"] = 4] = "Root";
    /**
     * Trainer role.
     * Access to scenes, activities, touchpoints...
     */
    UserRole[UserRole["Trainer"] = 5] = "Trainer";
    /** Facebook Employee role. */
    UserRole[UserRole["FacebookEmployee"] = 6] = "FacebookEmployee";
    /** Corporate Partner role. */
    UserRole[UserRole["CorporatePartner"] = 7] = "CorporatePartner";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
//# sourceMappingURL=enums.js.map